import './App.css';
import { Route, Routes, useNavigate } from 'react-router-dom';
import LoginSignup from './components/LoginSignup';
import Recognition from './components/Recognition';
import Dashboard from './components/Dashboard';

export default function App() {
  const navigate = useNavigate();

  const handleLoginSuccess = (userDetails) => {
    if(userDetails){
      navigate('/recognition');
    }
  };
  return (
    <div>
      <Routes>
        <Route path="/" 
          element={
             <div>
              <LoginSignup onLoginSuccess={handleLoginSuccess} />
            </div> 
          } />
        <Route path="/recognition" element={<Recognition />} />
        <Route path="/dashboard" element={<Dashboard /> } />
      </Routes>
    </div>
  );
}
